import React from "react";
import founderImg from "../assets/founder-olusayo-odunsi.jpg";

export default function SuccessProfile() {
  return (
    <section className="section section--alt" id="success-profile">
      <div className="container">
        <div className="spWrap">
          <div className="spCard">
            <div className="spTop">
              <div className="spKicker">Success Profile</div>
              <h2 className="spTitle">Scaling a National Icon</h2>
              <div className="spSub">The Medplus Story</div>
            </div>

            <p className="spBody">
              For 17 years, we have mastered the art of building world-class
              brands from small beginnings. Our journey with Medplus Pharmacy is
              the blueprint. By shifting their narrative and scaling their
              visibility, we helped pave the path from a local pharmacy to a
              national wellness destination with 100+ locations. SmartUp360 is
              the evolution of that success. We are applying that same "National
              Icon" DNA to your business, adding the industrial infrastructure
              and capital access required for the global stage.
            </p>

            <div className="spFounder">
              <div className="spFounder__media">
                <div className="spFounder__imgShell" aria-hidden="true">
                  <img
                    className="spFounder__img"
                    src={founderImg}
                    alt="Olusayo Odunsi"
                  />
                </div>
              </div>

              <div className="spFounder__copy">
                <div className="spFounder__label">A Note from the Founder</div>

                <div className="spQuote">
                  <div className="spQuote__mark" aria-hidden="true">
                    “
                  </div>
                  <p className="spQuote__text">
                    I built SmartUp360 because I saw the ceiling. I met
                    countless founders with world-class products who lacked the
                    bridge, the structure, the visibility, and the capital, to
                    get from the factory floor to the world. SmartUp360 is that
                    bridge. We aren't helping you scale. We are
                    institutionalizing your legacy.
                    <span className="spQuote__mark2" aria-hidden="true">
                      "
                    </span>{" "}
                    <br></br>
                    <span className="spSig__name">Olusayo Odunsi</span>
                  </p>
                </div>

                <div className="spSig">
                  <div className="spSig__tagline">
                    Built for Lagos. Scaled for the World. This is the Smart way
                    to scale.
                  </div>
                </div>

                <div className="spFounder__ctaRow">
                  <a className="btn btn--secondary" href="#pillars">
                    See the 3 pillars
                  </a>
                  <a
                    className="btn btn--primary"
                    href="http://waitlist.smartup360.com/"
                  >
                    Apply or join the waitlist
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="spGlow" aria-hidden="true" />
        </div>
      </div>
    </section>
  );
}
